import React, { useState, useEffect } from 'react';

const API = 'https://green-energy.com.co/api';

const PERMISOS_LISTA = [
  { key: 'dashboard',   label: '🏠 Dashboard',         desc: 'Ver el panel principal' },
  { key: 'monitor',     label: '📡 Monitor en vivo',   desc: 'Ver estado de cargadores' },
  { key: 'comandos',    label: '⚡ Enviar comandos',   desc: 'RemoteStart, Stop, Reset' },
  { key: 'historial',   label: '📋 Historial',         desc: 'Ver sesiones de carga' },
  { key: 'exportar',    label: '📊 Exportar reportes', desc: 'Descargar Excel' },
  { key: 'gestion',     label: '⚙️ Gestión de carga',  desc: 'Límites de SoC' },
  { key: 'alertas',     label: '🚨 Alertas',           desc: 'Ver y resolver alertas' },
  { key: 'uptime',      label: '📶 Uptime',            desc: 'Disponibilidad de cargadores' },
  { key: 'diagnostico', label: '🔬 Diagnóstico',       desc: 'Eficiencia de flota' },
  { key: 'limites',     label: '🔋 Límites de carga',  desc: 'Configurar límites de SoC por zonal' },
  { key: 'usuarios',    label: '👥 Usuarios',          desc: 'Administrar usuarios (solo admin)' },
];

const rolConfig = {
  admin:    { label:'Admin',        color:'#f87171', bg:'#3a1a1a' },
  operador: { label:'Operador',     color:'#60a5fa', bg:'#1a2a3a' },
  lectura:  { label:'Solo lectura', color:'var(--accent)', bg:'var(--accent3)' },
};

const permisosDefecto = {
  admin:    { dashboard:true, historial:true, alertas:true, monitor:true, comandos:true, gestion:true, usuarios:true, exportar:true, diagnostico:true, uptime:true },
  operador: { dashboard:true, historial:true, alertas:true, monitor:true, comandos:true, gestion:true, usuarios:false, exportar:true, diagnostico:true, uptime:true },
  lectura:  { dashboard:true, historial:true, alertas:true, monitor:true, comandos:false, gestion:false, usuarios:false, exportar:false, diagnostico:true, uptime:true },
};

export default function AdminUsuarios({ usuario }) {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [cambiarPwd, setCambiarPwd] = useState(null);
  const [nuevaPwd, setNuevaPwd] = useState('');
  const [savingPwd, setSavingPwd] = useState(false);
  const [form, setForm] = useState({ nombre:'', email:'', password:'', rol:'lectura', cop:'todos' });
  const [permsEdit, setPermsEdit] = useState({});
  const [rolEdit, setRolEdit] = useState('lectura');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  const fetchUsuarios = () => {
    fetch(`${API}/usuarios`, { headers: { 'x-user-email': usuario.email } })
      .then(r=>r.json()).then(data=>{ setUsuarios(data); setLoading(false); })
      .catch(()=>setLoading(false));
  };

  useEffect(() => { fetchUsuarios(); }, []);

  const showMsg = (ok, txt) => {
    setMsg({ok, txt});
    setTimeout(()=>setMsg(null), 4000);
  };

  const guardarUsuario = async () => {
    if (!form.nombre || !form.email || !form.password) { showMsg(false,'Completa todos los campos'); return; }
    setSaving(true);
    try {
      const resp = await fetch(`${API}/usuarios`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'x-user-email': usuario.email },
        body: JSON.stringify(form)
      });
      const data = await resp.json();
      if (data.ok) { showMsg(true,'Usuario creado correctamente'); setShowForm(false); setForm({nombre:'',email:'',password:'',rol:'lectura',cop:'todos'}); fetchUsuarios(); }
      else showMsg(false, data.error||'Error al crear usuario');
    } catch(e) { showMsg(false,'Error de conexión'); }
    setSaving(false);
  };

  const abrirEditar = (u) => {
    setEditando(u);
    let perms = {};
    try { perms = JSON.parse(u.permisos || '{}'); } catch(e) {}
    if (Object.keys(perms).length === 0) perms = permisosDefecto[u.rol] || permisosDefecto.lectura;
    setPermsEdit(perms);
    setRolEdit(u.rol);
  };

  const guardarPermisos = async () => {
    setSaving(true);
    try {
      const resp = await fetch(`${API}/usuarios/${editando.id}/permisos`, {
        method: 'PUT',
        headers: { 'Content-Type':'application/json', 'x-user-email': usuario.email },
        body: JSON.stringify({ permisos: permsEdit, rol: rolEdit })
      });
      const data = await resp.json();
      if (data.ok) { showMsg(true,'Permisos actualizados'); setEditando(null); fetchUsuarios(); }
      else showMsg(false, data.error||'Error');
    } catch(e) { showMsg(false,'Error de conexión'); }
    setSaving(false);
  };

  const cambiarPassword = async () => {
    if (!nuevaPwd || nuevaPwd.length < 6) { showMsg(false,'Mínimo 6 caracteres'); return; }
    setSavingPwd(true);
    try {
      const resp = await fetch(`${API}/usuarios/${cambiarPwd.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type':'application/json', 'x-user-email': usuario.email },
        body: JSON.stringify({ password: nuevaPwd })
      });
      const data = await resp.json();
      if (data.ok) { showMsg(true,`Contraseña de ${cambiarPwd.nombre} actualizada`); setCambiarPwd(null); setNuevaPwd(''); }
      else showMsg(false, data.error||'Error');
    } catch(e) { showMsg(false,'Error de conexión'); }
    setSavingPwd(false);
  };

  const toggleActivo = async (u) => {
    await fetch(`${API}/usuarios/${u.id}`, {
      method: 'PATCH',
      headers: { 'Content-Type':'application/json', 'x-user-email': usuario.email },
      body: JSON.stringify({ activo: u.activo ? 0 : 1 })
    });
    fetchUsuarios();
  };

  const aplicarRol = (rol) => {
    setRolEdit(rol);
    setPermsEdit({...permisosDefecto[rol]});
  };

  if (loading) return <div style={{padding:'3rem',textAlign:'center',color:'var(--text3)'}}>Cargando usuarios...</div>;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'1.5rem'}}>
        <div className="page-title" style={{margin:0}}>Administración de usuarios</div>
        <button onClick={()=>setShowForm(!showForm)}
          style={{padding:'10px 20px',background:'var(--accent-dark)',border:'1px solid var(--accent)',borderRadius:'8px',color:'#fff',cursor:'pointer',fontSize:'13px',fontWeight:'700'}}>
          + Nuevo usuario
        </button>
      </div>

      {msg && (
        <div style={{background:msg.ok?'var(--accent3)':'rgba(248,113,113,0.1)',border:`1px solid ${msg.ok?'var(--accent)':'#f87171'}`,borderRadius:'8px',padding:'10px 16px',marginBottom:'1.25rem',fontSize:'13px',color:msg.ok?'var(--accent)':'#f87171'}}>
          {msg.ok?'✅':'❌'} {msg.txt}
        </div>
      )}

      {/* Formulario nuevo usuario */}
      {showForm && (
        <div className="card" style={{marginBottom:'1.25rem'}}>
          <div className="card-title">Nuevo usuario</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'12px'}}>
            <div>
              <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'4px',textTransform:'uppercase'}}>Nombre completo</label>
              <input value={form.nombre} onChange={e=>setForm({...form,nombre:e.target.value})} placeholder="Nombre" style={{width:'100%'}} />
            </div>
            <div>
              <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'4px',textTransform:'uppercase'}}>Correo</label>
              <input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="correo@empresa.com" style={{width:'100%'}} />
            </div>
            <div>
              <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'4px',textTransform:'uppercase'}}>Contraseña</label>
              <input type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} placeholder="••••••••" style={{width:'100%'}} />
            </div>
            <div>
              <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'4px',textTransform:'uppercase'}}>COP</label>
              <select value={form.cop} onChange={e=>setForm({...form,cop:e.target.value})} style={{width:'100%'}}>
                <option value="todos">Todos los COP</option>
                <option value="Fontibón">Solo Fontibón</option>
                <option value="Usme">Solo Usme</option>
              </select>
            </div>
            <div>
              <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'4px',textTransform:'uppercase'}}>Rol base</label>
              <select value={form.rol} onChange={e=>setForm({...form,rol:e.target.value})} style={{width:'100%'}}>
                <option value="admin">Admin</option>
                <option value="operador">Operador</option>
                <option value="lectura">Solo lectura</option>
              </select>
            </div>
          </div>
          <div style={{display:'flex',gap:'8px'}}>
            <button onClick={guardarUsuario} disabled={saving}
              style={{padding:'10px 20px',background:'var(--accent-dark)',border:'1px solid var(--accent)',borderRadius:'7px',color:'#fff',cursor:'pointer',fontSize:'13px',fontWeight:'700'}}>
              {saving?'⏳ Guardando...':'✅ Crear usuario'}
            </button>
            <button onClick={()=>setShowForm(false)}
              style={{padding:'10px 16px',background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'7px',color:'var(--text2)',cursor:'pointer',fontSize:'13px'}}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Modal cambiar contraseña */}
      {cambiarPwd && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',zIndex:300,display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
          <div style={{background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'12px',width:'100%',maxWidth:'380px',padding:'1.5rem'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'1.5rem'}}>
              <div>
                <div style={{fontSize:'15px',fontWeight:'700',color:'var(--text)'}}>Cambiar contraseña</div>
                <div style={{fontSize:'12px',color:'var(--text3)',marginTop:'2px'}}>{cambiarPwd.nombre}</div>
              </div>
              <button onClick={()=>{setCambiarPwd(null);setNuevaPwd('');}}
                style={{padding:'5px 10px',background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'6px',color:'var(--text2)',cursor:'pointer'}}>✕</button>
            </div>
            <div style={{marginBottom:'1.25rem'}}>
              <label style={{fontSize:'11px',color:'var(--text3)',display:'block',marginBottom:'5px',textTransform:'uppercase'}}>Nueva contraseña</label>
              <input type="password" value={nuevaPwd} onChange={e=>setNuevaPwd(e.target.value)}
                placeholder="Mínimo 6 caracteres" style={{width:'100%'}} />
            </div>
            <div style={{display:'flex',gap:'8px'}}>
              <button onClick={()=>{setCambiarPwd(null);setNuevaPwd('');}}
                style={{flex:1,padding:'10px',background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'7px',color:'var(--text2)',cursor:'pointer',fontSize:'13px'}}>
                Cancelar
              </button>
              <button onClick={cambiarPassword} disabled={savingPwd}
                style={{flex:2,padding:'10px',background:'var(--accent-dark)',border:'1px solid var(--accent)',borderRadius:'7px',color:'#fff',cursor:'pointer',fontSize:'13px',fontWeight:'700'}}>
                {savingPwd?'⏳ Guardando...':'🔑 Cambiar contraseña'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal editar permisos */}
      {editando && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',zIndex:300,display:'flex',alignItems:'center',justifyContent:'center',padding:'1rem'}}>
          <div style={{background:'var(--bg2)',border:'1px solid var(--border)',borderRadius:'12px',width:'100%',maxWidth:'520px',padding:'1.5rem',maxHeight:'90vh',overflowY:'auto'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'1.5rem'}}>
              <div>
                <div style={{fontSize:'15px',fontWeight:'700',color:'var(--text)'}}>{editando.nombre}</div>
                <div style={{fontSize:'12px',color:'var(--text3)',marginTop:'2px'}}>{editando.email}</div>
              </div>
              <button onClick={()=>setEditando(null)} style={{padding:'5px 10px',background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'6px',color:'var(--text2)',cursor:'pointer'}}>✕</button>
            </div>

            <div style={{marginBottom:'1.25rem'}}>
              <div style={{fontSize:'11px',color:'var(--text3)',marginBottom:'8px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Rol base</div>
              <div style={{display:'flex',gap:'8px'}}>
                {['admin','operador','lectura'].map(r=>{
                  const rc=rolConfig[r];
                  return (
                    <button key={r} onClick={()=>aplicarRol(r)}
                      style={{flex:1,padding:'8px',border:`1px solid ${rolEdit===r?rc.color:'var(--border)'}`,borderRadius:'7px',
                        background:rolEdit===r?rc.bg:'var(--bg)',color:rolEdit===r?rc.color:'var(--text3)',cursor:'pointer',fontSize:'12px',fontWeight:'600'}}>
                      {rc.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div style={{fontSize:'11px',color:'var(--text3)',marginBottom:'10px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Permisos individuales</div>
            <div style={{display:'flex',flexDirection:'column',gap:'8px',marginBottom:'1.5rem'}}>
              {PERMISOS_LISTA.map(p => (
                <div key={p.key} onClick={()=>setPermsEdit(prev=>({...prev,[p.key]:!prev[p.key]}))}
                  style={{display:'flex',alignItems:'center',gap:'12px',padding:'10px 12px',borderRadius:'8px',cursor:'pointer',
                    background:permsEdit[p.key]?'var(--accent3)':'var(--bg)',
                    border:`1px solid ${permsEdit[p.key]?'var(--accent)':'var(--border)'}`}}>
                  <div style={{width:'22px',height:'22px',borderRadius:'6px',flexShrink:0,
                    border:`2px solid ${permsEdit[p.key]?'var(--accent)':'var(--border)'}`,
                    background:permsEdit[p.key]?'var(--accent)':'transparent',
                    display:'flex',alignItems:'center',justifyContent:'center',
                    color:'#000',fontSize:'13px',fontWeight:'800'}}>
                    {permsEdit[p.key]?'✓':''}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:'13px',fontWeight:'600',color:permsEdit[p.key]?'var(--text)':'var(--text2)'}}>{p.label}</div>
                    <div style={{fontSize:'11px',color:'var(--text4)',marginTop:'1px'}}>{p.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{display:'flex',gap:'8px'}}>
              <button onClick={()=>setEditando(null)}
                style={{flex:1,padding:'10px',background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'7px',color:'var(--text2)',cursor:'pointer',fontSize:'13px'}}>
                Cancelar
              </button>
              <button onClick={guardarPermisos} disabled={saving}
                style={{flex:2,padding:'10px',background:'var(--accent-dark)',border:'1px solid var(--accent)',borderRadius:'7px',color:'#fff',cursor:'pointer',fontSize:'13px',fontWeight:'700'}}>
                {saving?'⏳ Guardando...':'💾 Guardar permisos'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tabla de usuarios */}
      <div className="card">
        <table>
          <thead>
            <tr><th>#</th><th>Nombre</th><th>Correo</th><th>Rol</th><th>COP</th><th>Último acceso</th><th>Estado</th><th>Acciones</th></tr>
          </thead>
          <tbody>
            {usuarios.map(u => {
              const rc = rolConfig[u.rol]||rolConfig.lectura;
              return (
                <tr key={u.id}>
                  <td style={{color:'var(--text3)',fontSize:'12px'}}>{u.id}</td>
                  <td style={{fontWeight:'600',color:'var(--text)'}}>{u.nombre}</td>
                  <td style={{color:'var(--text2)',fontSize:'12px'}}>{u.email}</td>
                  <td><span style={{background:rc.bg,color:rc.color,padding:'2px 8px',borderRadius:'5px',fontSize:'11px',fontWeight:'600'}}>{rc.label}</span></td>
                  <td style={{color:'var(--text2)',fontSize:'12px'}}>{u.cop}</td>
                  <td style={{color:'var(--text3)',fontSize:'12px'}}>{u.last_login?new Date(u.last_login).toLocaleString('es-CO'):'Nunca'}</td>
                  <td>
                    <span style={{background:u.activo?'var(--accent3)':'var(--bg)',color:u.activo?'var(--accent)':'var(--text3)',padding:'2px 8px',borderRadius:'5px',fontSize:'11px',fontWeight:'600'}}>
                      {u.activo?'Activo':'Inactivo'}
                    </span>
                  </td>
                  <td>
                    <div style={{display:'flex',gap:'6px',flexWrap:'wrap'}}>
                      <button onClick={()=>abrirEditar(u)}
                        style={{padding:'4px 10px',background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'5px',color:'var(--text2)',cursor:'pointer',fontSize:'11px'}}>
                        ✏️ Permisos
                      </button>
                      <button onClick={()=>{setCambiarPwd(u);setNuevaPwd('');}}
                        style={{padding:'4px 10px',background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'5px',color:'#60a5fa',cursor:'pointer',fontSize:'11px'}}>
                        🔑 Password
                      </button>
                      {u.email !== usuario.email && (
                        <button onClick={()=>toggleActivo(u)}
                          style={{padding:'4px 10px',background:'var(--bg)',border:'1px solid var(--border)',borderRadius:'5px',color:'var(--text3)',cursor:'pointer',fontSize:'11px'}}>
                          {u.activo?'Desactivar':'Activar'}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
